import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Bootstrap (themed via our tokens) + typography + global utilities
import '@/styles/main.scss';
// Icon set used throughout the app (bi-* classes)
import 'bootstrap-icons/font/bootstrap-icons.css';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
